import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tfr-page',
  templateUrl: './tfr-page.component.html',
  styleUrls: ['./tfr-page.component.scss']
})
export class TfrPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
